import React, { useRef, useCallback, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/virtual";

const Modal = ({ isOpen, closeModal, variable1, variable2 }) => {

  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const [images, setImages] = useState([]);
  const [liga, setLiga] = useState();
  const [btn, setBtn] = useState(
    ``
  );

  useEffect(() => {
    if (!isOpen) return;
    
    try {
      const imageUrls = variable1.match(/src="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setImages(imageUrls)
    } catch (e) {
      if(variable2 === 'video')
      {
        console.log("Es video");
        const dummyImages = ['dummy1.jpg', 'dummy2.jpg', 'dummy3.jpg'];
        setImages(dummyImages);
      }
    };

    

    try {
      const ligaUrls = variable1.match(/href="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setBtn(`<a class='btn-idea-blog-a' href='` + ligaUrls + `' >Leer blog</a>`);

    } catch (e) {
      console.log("sin liga")
    };


    
  }, [isOpen]);

  if (!isOpen || images.length === 0) return null;

  if (variable2 === 'carrete') {
    return (
      <div className="modal">
        <div className="modalContent">
          <div className='div-f-carrusel'>
            <Swiper
              ref={sliderRef}
              spaceBetween={10}
              modules={[Autoplay, Navigation, Pagination]}
              effect="carousel"
              grabCursor={true}
              navigation={{
                nextEl: '.swiper-button-next', // Specify the correct selector for the next button
                prevEl: '.swiper-button-prev', // Specify the correct selector for the previous button
              }}
              pagination={{ clickable: true }}
              className="modal-swiper"
            >
              {images.map((imageUrl, index) => (
                <SwiperSlide key={index}>
                  <img className='swipperImage' src={imageUrl} alt={`Slide ${index + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div
              className="swiper-button-next"
              onClick={() => {
                // handleNext();
              }}
            />
            <div
              className="swiper-button-prev"
              onClick={() => {
                // handlePrev();
              }}
            ></div>
          </div>
          <div className='btn-idea-blog' dangerouslySetInnerHTML={{ __html: btn }} />
          <button className="botonPop" onClick={closeModal}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="background_gri"></div>
      </div>
    );
  } else {
    if (variable2 === 'video') {
      return (
      <div className="modal">
          <div className="modalContent">
            
            <div className='div_otro'> 
            <video autoplay controls>
              <source src={variable1} type="video/mp4" />
            </video>
            </div>
            <button
              className="botonPop"
              onClick={() => {
                closeModal();
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="background_gri"></div>
        </div>
      );
    }
    else {
      variable1 = variable1.replace('leer entrada', 'Leer blog');
      return (
        <div className="modal">
          <div className="modalContent">
            <div className='div_otro' dangerouslySetInnerHTML={{ __html: variable1 }} />
            <button
              className="botonPop"
              onClick={() => {
                closeModal();
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="background_gri"></div>
        </div>
      );
    }
  }
};

export default Modal;